import {
  getSchedulingInfo,
  alterationConstruction,
  saveDisclose,
  confirmStart,
  saveAlteration,
  getAlterationInfo,
  auditAlteration,
  getMessageList
} from '@/api/deliveryV2'
const state = {

}
const mutations = {

}
const actions = {
  getSchedulingInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getSchedulingInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A- 工程交底 - 0701 - 工期变更
  alterationConstruction(temp, data) {
    return new Promise((resolve, reject) => {
      alterationConstruction(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveDisclose(temp, data) {
    return new Promise((resolve, reject) => {
      saveDisclose(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A- 工程交底 - 07 - 确认开工
  confirmStart(temp, data) {
    return new Promise((resolve, reject) => {
      confirmStart(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveAlteration(temp, data) {
    return new Promise((resolve, reject) => {
      saveAlteration(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAlterationInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getAlterationInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  auditAlteration(temp, data) {
    return new Promise((resolve, reject) => {
      auditAlteration(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMessageList(temp, data) {
    return new Promise((resolve, reject) => {
      getMessageList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
